<template>
  <SpecialPromoBanner v-if="promoStore.banner.message" />
  <StripBanner
    v-else-if="bannerItemsToDisplay.length"
    :banner-items="bannerItemsToDisplay"
    :theme-override="promoBannerData.globalBanner.themeOverride"
  />
</template>

<script setup>
import bannerMessageQuery from '~/gql/globalBanner.gql'
const promoStore = usePromoStore()

const { $sentry } = useNuxtApp()

const { data: promoBannerData, error } = await useDatoQuery({
  query: bannerMessageQuery,
  prefetchedRequest: 'globalBanner'
})

if (error.value) {
  $sentry.captureException(error)
}

const bannerItemsToDisplay = computed(() => {
  return messagesToDisplay.value.map((item) => {
    return {
      id: item.id,
      text: parseMessage(item.bannerMessage),
      mobileLine1: parseMessage(item.mobileBannerMessageLine1),
      mobileLine2: parseMessage(item.mobileBannerMessageLine2),
      linkedContent: item.linkedContent,
      externalLink: item.externalLink,
      link: item.link
    }
  })
})

const bannerMsgsFromResponse = computed(() => {
  return promoBannerData.value?.globalBanner?.globalBannerMessages || []
})

const enabledMessages = computed(() => {
  return bannerMsgsFromResponse.value.filter(
    (bannerMsg) => bannerMsg.enabled
  )
})

const activeMessages = computed(() => {
  return enabledMessages.value.filter((bannerMsg) => {
    if (bannerMsg.hasGlobalPromo && !bannerMsg.globalPromo) return false

    if (!bannerMsg.activeFrom && !bannerMsg.activeUntil) return true

    const currentTimestamp = Date.parse(new Date())

    if (bannerMsg.activeFrom && !bannerMsg.activeUntil) {
      return Date.parse(bannerMsg.activeFrom) < currentTimestamp
    } else if (!bannerMsg.activeFrom && bannerMsg.activeUntil) {
      return Date.parse(bannerMsg.activeUntil) > currentTimestamp
    } else if (bannerMsg.activeFrom && bannerMsg.activeUntil) {
      return (
        Date.parse(bannerMsg.activeFrom) < currentTimestamp &&
        Date.parse(bannerMsg.activeUntil) > currentTimestamp
      )
    }

    return true
  })
})

const messagesToDisplay = computed(() => {
  return activeMessages.value.filter((enabledMsg) =>
    enabledMsg.globalPromo
      ? enabledMsg.globalPromo._status !== 'draft'
      : true
  )
})

function parseMessage(message) {
  // Support **bold**, __italic__ and ~~underline~~
  const bold = /(\*{2})(.*?)(\*{2})/g
  const italic = /(_{2})(.*?)(_{2})/g
  const underline = /(~{2})(.*?)(~{2})/g

  let parsedMessage = message
  parsedMessage = parsedMessage.replace(bold, '<b>$2</b>')
  parsedMessage = parsedMessage.replace(italic, '<i>$2</i>')
  parsedMessage = parsedMessage.replace(underline, '<u>$2</u>')

  return parsedMessage
}
</script>
